export const TitleDisplayer = (props) => {
    var unit = props.unit

    if (unit === 'Km' || unit === 'Meter') return 'Distance'
    if (unit === 'Steps') return 'Steps'
    if (unit === 'Time') return 'Duration'
    if (unit === 'Points') return 'Points'
    else return 'Value'
}
